import React from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { Dashboard } from '../pages/Dashboard';
import { SignIn } from '../pages/SignIn';
import LaudoView from '../pages/laudo';
import { SignInBusiness } from '../pages/SignIn-business';

export function PrivateRoutes() {
  const tokenPhato = sessionStorage.getItem('@cedapp:tokenPhato');
  const tokenLaureano = sessionStorage.getItem('@cedapp:tokenLaureano');
  const tokenHnsn = sessionStorage.getItem('@cedapp:tokenHnsn');
  const tokenLaureanoSoul = sessionStorage.getItem('@cedapp:tokenLaureanoSoul');

  if (
    !tokenPhato &&
    !tokenLaureano &&
    !tokenHnsn &&
    !tokenLaureanoSoul
  ) {
    return <Redirect to="/login" />;
  }

  return (
    <BrowserRouter>
      <Switch>
        <Route path="/" exact component={Dashboard} />
        <Route path="/home" exact component={Dashboard} />
        <Route path="/laudo/:cdLaudo" component={LaudoView} />
      </Switch>
    </BrowserRouter>
  );
}
export function Routes() {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/login/business" component={SignInBusiness} exact />
        <Route path="/login" component={SignIn} />
        <Route path="/*" component={PrivateRoutes} />
        <Route path="/laudo/:cdLaudo" component={LaudoView} />
      </Switch>
    </BrowserRouter>
  );
}
